import { useEffect } from 'react';
import '../useEventCallback/index.js';
import useEventCallback from '../useEventCallback/useEventCallback.js';

function isEventTarget(target) {
  return !!target.addEventListener;
}
/**
 * Adds and cleans up event listener from the specified target
 * @param targetOrRef - An event target or ref pointing to one.
 * @param event - Event to listen for.
 * @param handler - Handler to call when event is fired.
 * @param options.isCaptureEvent - Whether to run the event in the capture phase,
 * defaults to false (i.e. run in bubbling phase)
 * @param options.enabled - Whether event is enabled, defaults to true
 * @param options.additionalDependencies - additional dependencies to add to the use effect
 * should be a static list of values, defaults to []
 */
function useEventListener(targetOrRef, event, handler) {
  let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  const listener = useEventCallback(handler);
  const {
    isCaptureEvent = false,
    isDisabled = false,
    additionalDependencies = []
  } = options;
  useEffect(() => {
    if (!targetOrRef) {
      return undefined;
    }
    const target = isEventTarget(targetOrRef) ? targetOrRef : targetOrRef.current;
    if (target !== null && target !== void 0 && target.addEventListener && !isDisabled) {
      target.addEventListener(event, listener, isCaptureEvent);
      return () => target.removeEventListener(event, listener, isCaptureEvent);
    }
    return undefined;
  }, [targetOrRef, event, listener, isCaptureEvent, isDisabled, ...additionalDependencies]);
}

export { useEventListener as default };
